import { PaximizerCommunicationSectionFragment, PaximizerCommunicationSectionEnum } from '@websky/graphql';

export const SET_CATEGORIES = 'COMMUNICATIONS/SET_CATEGORIES' as const;
export const MARK_MESSAGE_AS_READ = 'COMMUNICATIONS/MARK_MESSAGE_AS_READ' as const;
export const MARK_CATEGORY_AS_READ = 'COMMUNICATIONS/MARK_CATEGORY_AS_READ' as const;
export const RESTORE_CATEGORY_UNREAD_COUNT = 'COMMUNICATIONS/RESTORE_CATEGORY_UNREAD_COUNT' as const;
export const SET_TEASERS_LOADING = 'COMMUNICATIONS/SET_TEASERS_LOADING' as const;
export const SET_CATEGORIES_LOADING = 'COMMUNICATIONS/SET_CATEGORIES_LOADING' as const;
export const SET_MARK_AS_READ_LOADING = 'COMMUNICATIONS/SET_MARK_AS_READ_LOADING' as const;
export const SET_UNREAD_TOTAL = 'COMMUNICATIONS/SET_UNREAD_TOTAL' as const;

export const setCategories = (payload: PaximizerCommunicationSectionFragment[]) => ({
	type: SET_CATEGORIES,
	payload
});

export const setUnreadTotal = (payload: number) => ({
	type: SET_UNREAD_TOTAL,
	payload
});

export const markMessageAsRead = (payload: PaximizerCommunicationSectionEnum) => ({
	type: MARK_MESSAGE_AS_READ,
	payload
});

export const markCategoryAsRead = (payload: PaximizerCommunicationSectionEnum) => ({
	type: MARK_CATEGORY_AS_READ,
	payload
});

export const restoreCategoryUnreadCount = (payload: {
	categoryId: PaximizerCommunicationSectionEnum;
	count: number;
}) => ({
	type: RESTORE_CATEGORY_UNREAD_COUNT,
	payload
});

export const setTeasersLoading = (payload: boolean) => ({
	type: SET_TEASERS_LOADING,
	payload
});

export const setCategoriesLoading = (payload: boolean) => ({
	type: SET_CATEGORIES_LOADING,
	payload
});

export const setMarkCategoryAsReadLoading = (payload: boolean) => ({
	type: SET_MARK_AS_READ_LOADING,
	payload
});

export type SetCategoriesAction = ReturnType<typeof setCategories>;
export type MarkMessageAsReadAction = ReturnType<typeof markMessageAsRead>;
export type MarkCategoryAsReadAction = ReturnType<typeof markCategoryAsRead>;
export type RestoreCategoryUnreadCountAction = ReturnType<typeof restoreCategoryUnreadCount>;
export type SetTeasersLoadingAction = ReturnType<typeof setTeasersLoading>;
export type SetCategoriesLoadingAction = ReturnType<typeof setCategoriesLoading>;
export type SetMarkCategoryAsReadLoadingAction = ReturnType<typeof setMarkCategoryAsReadLoading>;
export type SetUnreadTotalAction = ReturnType<typeof setUnreadTotal>;

export type ActionCommunicationsTypes =
	| SetCategoriesAction
	| MarkMessageAsReadAction
	| MarkCategoryAsReadAction
	| RestoreCategoryUnreadCountAction
	| SetTeasersLoadingAction
	| SetCategoriesLoadingAction
	| SetMarkCategoryAsReadLoadingAction
	| SetUnreadTotalAction;
